<template>
    <hts-drawer
        v-model="visible"
        color="main"
        size="xl"
        :title="$t('labels.orderDetail')"
        @close="close">
        <div :style="{ minWidth: minWidthScroll }">
            <div class="p-3 grid grid-cols-4 gap-4">
                <div class="flex flex-col gap-2">
                    <p class="text-2xl text-main-600">
                        {{ $t('labels.customer') }}
                    </p>

                    <p class="font-bold">
                        {{ dataOrder.customerName }}
                    </p>
                    <p v-if="dataOrder.customerAddress">
                        Địa chỉ: {{ dataOrder.customerAddress }}
                    </p>
                    <p v-if="dataOrder.contactName">
                        {{ $t('labels.businessContact') }}: {{ dataOrder.contactName }} - {{ dataOrder.contactPhone }} - {{ dataOrder.contactEmail }}
                    </p>
                    <p v-if="dataOrder.logisticContactName">
                        {{ $t('labels.logisticContact') }}: {{ dataOrder?.logisticContactName }} - {{ dataOrder?.logisticContactPhone }} -
                        {{ dataOrder?.logisticContactEmail }}
                    </p>

                    <div class="flex flex-wrap">
                        <p class="font-bold w-52 float-start">
                            Trạng thái vận chuyển:
                        </p>
                        <hts-status
                            module="orderStatus"
                            :status="dataOrder.status"
                            size="medium"
                            label="" />
                    </div>
                    <div class="flex flex-wrap">
                        <p class="font-bold w-52 float-start">
                            Trạng thái phân bổ:
                        </p>
                        <hts-status
                            module="orderAllocationStatus"
                            :status="dataOrder.allocationStatus"
                            size="medium"
                            :params="{
                                data: {
                                    allotted: dataOrder.allotted,
                                    productivityOrder: dataOrder.productivityOrder
                                }
                            }"
                            label="" />
                    </div>
                </div>
                <div>
                    <p class="text-2xl text-main-600">
                        {{ $t('labels.route') }}
                    </p>
                    <ul
                        v-if="dataOrder.positions && dataOrder.positions.length"
                        class="steps steps-vertical w-full">
                        <li
                            v-for="(item, index) in dataOrder.positions"
                            :key="index"
                            data-content=" "
                            class="step float w-full">
                            <div class="flex items-center justify-center w-full">
                                <div
                                    class="items-center w-full text-left"
                                    :class="{
                                        'py-4': index !== 0
                                    }">
                                    <p class="font-bold">
                                        {{ item.fullNameNode }}
                                    </p>
                                    <p
                                        v-if="item.locationName"
                                        class="pt-1">
                                        {{ item.locationName }}
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div>
                    <p class="text-2xl text-main-600">
                        {{ $t('labels.otherInformation') }}
                    </p>
                    <p class="font-bold mt-2">
                        {{ $t('labels.commodity') }}
                    </p>
                    <p class="mb-2">
                        <span class="text-no first-letter:capitalize">
                            {{ dataOrder.commodityCategory }}
                        </span>
                        <span v-if="dataOrder.commodityCategory">
                            :
                        </span>
                        <span class="first-letter:capitalize">
                            {{ dataOrder.commodityName }}
                        </span>
                        <span v-if="dataOrder.goodsStatusName">
                            -
                        </span>
                        <span class="first-letter:capitalize">
                            {{ dataOrder.goodsStatusName }}
                        </span>
                    </p>

                    <div v-if="dataOrder.transportation === 'NON_CONTAINER'">
                        <p class="font-bold mt-2">
                            {{ $t('labels.vehicleType') }}
                        </p>
                        <p class="mb-2">
                            {{ dataOrder.vehicleCategoryName }}
                        </p>
                    </div>
                    <div v-else>
                        <p class="font-bold mt-2">
                            {{ $t('labels.containerType') }}
                        </p>
                        <p class="mb-2">
                            <span>
                                {{ dataOrder.contCategory }} feet
                            </span>
                            <span v-if="dataOrder.headContainer || dataOrder.mergeContainer">
                                - {{ dataOrder.headContainer ? `${$t('labels.headContainer')}` : '' }}{{ dataOrder.headContainer && dataOrder.mergeContainer ? ',' : ''
                                }}{{ dataOrder.mergeContainer ? `${$t('labels.mergeContainer')} ` : '' }}
                            </span>
                        </p>
                    </div>

                    <p class="font-bold mt-2">
                        {{ $t('labels.productivity') }}
                    </p>
                    <p class="mb-2">
                        {{ $formatters.formatNumber(dataOrder.productivityOrder || 0) }}
                        {{ dataOrder.transportation === 'NON_CONTAINER' ? $t('labels.vehicle') : $t('labels.container') }}
                    </p>
                </div>

                <!-- // Số cont -->
                <div>
                    <p class="text-2xl text-main-600">
                        Danh sách container
                    </p>
                    <!--
                      <div class="flex justify-end">
                      <add-container-numbers
                      :order-id="dataOrder._id"
                      :order-code="dataOrder.code"
                      @update-container-numbers="getContainerNumbers" />
                      </div>
                    -->

                    <div
                        v-if="containerNumbers?.length"
                        :loading="loadingContainerNumbers"
                        class="max-h-[400px] overflow-y-scroll">
                        <table class="table">
                            <thead>
                                <tr>
                                    <!-- <th class="w-[8px] items-center" /> -->
                                    <th class="w-1/3">
                                        Số cont
                                    </th>
                                    <th class="w-1/3">
                                        Mã chặng
                                    </th>
                                    <th class="w-1/3">
                                        Mã Chuyến
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr
                                    v-for="(containerNumber, index) in containerNumbers"
                                    :key="index">
                                    <!--
                                      <th class="w-[8px] items-center">
                                      {{ index + 1 }}
                                      </th>
                                    -->
                                    <td class="w-1/3">
                                        {{ containerNumber?.containerNumber || '' }}
                                    </td>
                                    <td class="w-1/3">
                                        <p
                                            v-for="(journey, index2) in getJourneyCodeHaveContainerNumber(containerNumber?.journey)"
                                            :key="index2"
                                            class="inline-block mr-2 whitespace-nowrap text-info-500 hover:text-info-700">
                                            <router-link :to="nextJourneyRoute(journey)">
                                                {{ journey.code }}
                                            </router-link>
                                        </p>
                                    </td>
                                    <td class="w-1/3">
                                        <p class="inline-block mr-2 whitespace-nowrap text-info-500 hover:text-info-700">
                                            <router-link :to="nextTripRoute(containerNumber?.trip)">
                                                {{ containerNumber?.trip?.code }}
                                            </router-link>
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <p>
                            Chưa có số container
                        </p>
                    </div>
                </div>
            </div>
            <div class="mx-5">
                <hts-ui-tabs
                    v-model="tapSelected"
                    :tabs="tabs"
                    @click="(key:string) => showShippingPlan(key)" />

                <div v-if="tapSelected === 'general-information'">
                    <general-information :data-order="dataOrder" />
                </div>

                <div v-if="tapSelected === 'plan'">
                    <shipping-plan :data-order="dataOrder" />
                </div>

                <div v-if="tapSelected === 'allotment'">
                    <allotment
                        :data-order="dataOrder"
                        @updateAllotment="
                            () => {
                                updateTableManagement()
                                getContainerNumbers()
                            }
                        "
                        @reload-container-number="getContainerNumbers" />
                </div>

                <div v-if="tapSelected === 'quote'">
                    <quote
                        :data-order="dataOrder"
                        @updateOrder="updateOrder" />
                </div>
                <div v-if="tapSelected === 'prices'">
                    <hts-charges
                        v-model="dataOrder.charges"
                        name-key="tripCode"
                        name-label="Chuyến" />
                </div>
            </div>

            <div class="h-20" />

            <workflow-position
                ref="workflowPosition"
                disabled />
            <view-position
                ref="viewPosition"
                disabled />
        </div>
    </hts-drawer>
</template>
<script setup lang="ts">
import Derection from '../plugins/direction'
import ViewPosition from '../view-position.vue'
import WorkflowPosition from '../workflow-position.vue'
import Allotment from './allotment.vue'
import GeneralInformation from './general-information.vue'
import Quote from './quote.vue'
import ShippingPlan from './shipping-plan.vue'
// import data from '~/pages/trucker-[id]/order/ignore/imports/data'
import { $api, $urlClient } from '#imports'
import { checkPermission } from '@/utils/permission-check'
import layoutPermissions from '~/data/permissions/layout-permissions'
import form from '~/pages/trucker-[id]/order/ignore/imports/form'

import screen from '~/components/utils/screen'
const { $formatters, $event } = useNuxtApp()
const { map: mapStore } = $store()

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm + 50}px`
})

const { listLabelCont } = Derection()

const loading = ref(true)
const visible = ref(false)

const emits = defineEmits(['refreshTables'])

const dataOrder = ref<any>({ ...form.initDataAddOrder })
const dataContact = ref<{ [key: string]: any }>({})
const shippingPlan = ref()
const shippingPlanData = ref<any>()
const viewShippingPlan = ref(false)
const customerRequestPages = ref(1)
const workflowPosition = ref()
const route = useRoute()
const tapSelected = ref('')
const containerNumbers = ref<{ [key: string]: any }[]>([])
const loadingContainerNumbers = ref<boolean>(false)

const open = async (id: string, tap?: string) => {
  mapStore.setShowLocation({ order: false })
  await getData(id)

  const t = route.query.tap || tap || ''
  if (t && typeof t === 'string') {
    tapSelected.value = t
  } else {
    tapSelected.value = 'general-information'
  }
  visible.value = true

  listenUpdate()
}

const getData = async (id: string) => {
  const api = $urlClient.order.order.detail
  const data: any = await $api(api, { uriParams: { ID: id } })
  const resData: any = data.data.value

  if (resData?.success) {
    dataOrder.value = resData.data

    dataContact.value.phone = resData.data?.contactPhone || ''
    dataContact.value.email = resData.data?.contactEmail || ''

    shippingPlanData.value = resData.data.shippingPlan

    if (resData.data.createOrderFrom === 'CUSTOMER_REQUEST') {
      if (resData.data.transportation && resData.data.transportation === 'CONTAINER') {
        dataOrder.value.contName = listLabelCont[resData.data.contCategory] ?? ''
      }
    }

    loading.value = false
  }

  getContainerNumbers()
}

const showShippingPlan = (key: string) => {
  if (key !== 'plan') {
    return
  }

  nextTick(() => {
    shippingPlan.value?.show(dataOrder.value.positions, dataOrder.value.shippingPlan)
  })
}

const close = () => {
  resetFields()
  updateTableManagement()
  useRouter().replace({ query: {} })
  unListenUpdate()
  visible.value = false
  tapSelected.value = 'general-information'
  loading.value = true
}

const updateTableManagement = () => {
  emits('refreshTables')
}

const resetFields = (withoutCreateOrderFrom?: false) => {
  dataOrder.value = {
    quote: null,
    charge: null,
    chargeName: null,
    chargeData: {} as { [key: string]: string },
    workingTimeRequest: [],
    productivityOrder: null,
    transportation: null,
    positions: [],
    createOrderFrom: withoutCreateOrderFrom ? dataOrder.value.createOrderFrom : 'QUOTE'
  }
  dataContact.value = {}
  viewShippingPlan.value = false
  customerRequestPages.value = 1

  if (shippingPlan.value) {
    shippingPlan.value.close()
  }
}

const updateOrder = (order: { [key: string]: any }) => {
  dataOrder.value = order
  updateTableManagement()
}

const listenUpdate = () => {
  if (process.client) {
    $event.listen(`order-${dataOrder.value._id}`, (value: any) => {
      value = value || {}

      dataOrder.value.confirmTripNumber = value.confirmTripNumber
      dataOrder.value.rejectTripNumber = value.rejectTripNumber
      dataOrder.value.waitingForAllocation = value.waitingForAllocation
      dataOrder.value.cancelTripNumber = value.cancelTripNumber
      dataOrder.value.allotment = value.allotment
      dataOrder.value.allotted = value.allotted
      if (typeof value.allocationStatus === 'number') {
        dataOrder.value.allocationStatus = value.allocationStatus
      }
      if (typeof value.status === 'number') {
        dataOrder.value.status = value.status
      }
    })
  }
}

const unListenUpdate = () => {
  if (process.client) {
    $event.unsubscribe(`order-${dataOrder.value._id}`, () => {})
  }
}

const tabs = computed(() => {
  const data = [
    {
      key: 'general-information',
      label: $t('labels.generalInformation'),
      active: true
    },
    { key: 'plan', label: $t('labels.plan') },
    { key: 'allotment', label: $t('labels.allotment'), permission: checkPermission(layoutPermissions.order_allotment) },
    { key: 'quote', label: $t('labels.quote'), permission: checkPermission(layoutPermissions.quote_management) },
    { key: 'prices', label: $t('labels.prices'), permission: checkPermission(['order_pricing_view']) }
  ]
  return data
})

const getContainerNumbers = () => {
  loadingContainerNumbers.value = true
  const url = $urlClient.order.order.getContainerNumbers

  $api(url, { uriParams: { ID: dataOrder.value._id } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        containerNumbers.value = resData.data?.containerNumbers || []
      } else {
        containerNumbers.value = []
      }
      loadingContainerNumbers.value = false
    })
    .catch(() => {
      loadingContainerNumbers.value = false
      containerNumbers.value = []
    })
}

const getJourneyCodeHaveContainerNumber = (journeys: any[]) => {
  if (!journeys || !journeys.length) {
    return ''
  }

  let js = journeys.map((j) => (j.code ? j : ''))

  js = js.filter((c) => c)

  return js
}

const nextJourneyRoute = (item: any) => {
  if (!item) {
    return null
  }
  return {
    name: 'c-id-journey-management',
    query: { journeyId: item?._id, action: 'view' }
  }
}

const nextTripRoute = (item: any) => {
  if (!item) {
    return null
  }
  return {
    name: 'c-id-trip',
    query: { id: item?._id, action: 'view' }
  }
}

defineExpose({
  open,
  close,
  resetFields
})

const viewPosition = ref()
</script>
